import React, { useState } from 'react'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { PdcaCycleForm } from './components'

const PdcaCycleNew = ({ match }) => {
  const { pdcaId } = match.params
  const [loading, setLoading] = useState(false)

  return (
    <Page title="Novo ciclo de PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={loading} />
        <ContentHeader title="Novo ciclo de PDCA" />
        <PdcaCycleForm setLoading={setLoading} mode="new" pdcaId={pdcaId} />
      </Container>
    </Page>
  )
}

export default PdcaCycleNew
